<template>
<!-- 
儲存 primary
編輯儲存primary
另存 primary
刪除 error
送出 success
收回 error
駁回 error
核准 primary
結案primary
公告 success
回復修正 warning
 -->
<div>
  <v-row>
    <v-col cols="12" md="12" class="d-flex justify-end pa-0">
      <v-col cols="4" class="d-flex justify-end">
        <div class="d-flex" v-if="project.status==flow[0]&&!isDelete&&userDataCookie.userno==project.applyUser">
          <VBtn v-if="applicationNumber" 
          class="mr-2" 
          variant="tonal" 
          color="primary" 
          :loading="loadingBtn"
          @click="editSave">
          編輯儲存
          </VBtn>
          <VBtn v-else 
          class="mr-2" 
          variant="tonal" 
          color="primary" 
          :loading="loadingBtn"
          @click="save">
          儲存
          </VBtn>
          <VBtn v-if="applicationNumber" 
          variant="tonal" 
          color="error" 
          class="mr-2"  
          :loading="loadingBtn"
          @click="deleteBtn">
          刪除
          </VBtn>
          <VBtn v-if="applicationNumber" 
          class="mr-2" 
          variant="tonal" 
          color="success" 
          :loading="loadingBtn"
          @click="send">
          送出
          </VBtn>
        </div>
        <!-- 取得可執行動作API -->
        <div class="d-flex" v-if="actionBtn&&actionBtn.status&&actionBtn.status?.status=='R'">
          <VBtn v-if="actionBtn && actionBtn.actions && actionBtn.actions.ableToRevoke" 
          @click="revoke" 
          variant="tonal" 
          color="error" 
          :loading="loadingBtn"
          class="mr-2"
          >收回
          </VBtn>
          <VBtn v-if="actionBtn&& actionBtn.actions&&actionBtn.actions.ableToReject" 
          variant="tonal"
           color="error" 
           @click="reject" 
          :loading="loadingBtn"
           class="mr-2">
           駁回
           </VBtn>
          <VBtn v-if="actionBtn&& actionBtn.actions&&actionBtn.actions.ableToApprove"  
          variant="tonal"
          color="primary"
           @click="approve" 
          :loading="loadingBtn"
           class="mr-2">
           核准
           </VBtn>
        </div>
        <div class="d-flex" v-if="(project.status==flow[4]||project.status==flow[6])&&userDataCookie.userno==project.applyUser">
          <VBtn variant="tonal" 
          v-if="!dialogBtn" 
          color="success" 
          class="mr-2" 
          :loading="loadingBtn"
          @click="handleDialogVisiable">
          建議參賽名單通知
          </VBtn>
          <VBtn variant="tonal" 
          v-if="dialogBtn" 
          color="primary" 
          class="mr-2" 
          :loading="loadingBtn"
          @click="endCase">
          結案
          </VBtn>
        </div>
      </v-col>
    </v-col>
  </v-row>
  <v-form ref="formRef">
  <v-row>
    <v-col cols="12" md="8">
      <v-card width="100%" height="100%">
        <v-card-text>
            <v-row>
              <!-- {{totalTabs}} -->
              <v-col cols="12">
                <div class="text-subtitle-2 text-high-emphasis">項目標題<Required/></div>
                <AppTextField :disabled="isDelete" label="" v-model="project.title" :rules="[rules.required]" required></AppTextField>
              </v-col>
              <v-col cols="12">
                <div class="text-subtitle-2 text-high-emphasis">公文上傳<Required/></div>
                <VRow>
                  <VCol cols="12">
                    <div v-if="typeof project.document=='string'&&project.document" class="d-flex justify-space-between">
                      <div>
                        <v-icon icon="tabler-paperclip"></v-icon>
                        <a target="_blank" class="ml-2" @click.prevent="getJwtBeforeRedirect(project.documentId)" href="">{{project.document}}</a>
                      </div>
                      <v-btn class="bg-white" color="black" variants="text" icon="tabler-x" @click="clear('document')"></v-btn>
                    </div>
                    <VFileInput :rules="[rules.required]" v-else accept=".pdf" :disabled="isDelete" v-model="project.document" @change="handleOfficalPdfFile('documentId')" @click:clear="clear('document')"/>
                  </VCol>
                </VRow>
              </v-col>
              <v-col cols="12">
                <div class="text-subtitle-2 text-high-emphasis">計畫範例<Required/></div>
                <VRow>
                  <VCol cols="12">
                    <div v-if="typeof project.example=='string'&&project.example" class="d-flex justify-space-between">
                      <div>
                        <v-icon icon="tabler-paperclip"></v-icon>
                        <a target="_blank"  class="ml-2" @click.prevent="getJwtBeforeRedirect(project.exampleId)" href="" >{{project.example}}</a>
                      </div>
                      <v-btn class="bg-white" color="black" variants="text" icon="tabler-x" @click="clear('example')"></v-btn>
                    </div>
                    <VFileInput :rules="[rules.required]" v-else :disabled="isDelete" v-model="project.example" @change="handleOfficalFile('example')" @click="clear('example')"/>
                  </VCol>
                </VRow>
              </v-col>
              <v-col cols="12">
                <div class="text-subtitle-2 text-high-emphasis">遴選辦法範例<Required/></div>
                <VRow>
                  <VCol cols="12">
                    <div v-if="typeof project.memberSampleFile=='string'&&project.memberSampleFile" class="d-flex justify-space-between">
                      <div>
                        <v-icon icon="tabler-paperclip"></v-icon>
                        <a target="_blank" class="ml-2" @click.prevent="getJwtBeforeRedirect(project.memberSampleFileId)" href="">{{project.memberSampleFile}}</a>
                      </div>
                      <v-btn class="bg-white" color="black" variants="text" icon="tabler-x" @click="clearMultiple('memberSampleFile')"></v-btn>
                    </div>
                    <VFileInput counter show-size multiple :rules="[rules.fileLimitLength]" v-else :disabled="isDelete" v-model="project.memberSampleFile" @change="handleOfficalFileMultiple('memberSampleFile')" @click="clearMultiple('memberSampleFile')"/>
                  </VCol>
                </VRow>
              </v-col>
              <v-col cols="12">
                <div class="text-subtitle-2 text-high-emphasis">相關附件</div>
                <VRow>
                  <VCol cols="12">
                    <!-- {{project.attachment}} -->
                    <div v-if="typeof project.attachment=='string'&&project.attachment" class="d-flex justify-space-between">
                      <div>
                        <v-icon icon="tabler-paperclip"></v-icon>
                        <a target="_blank"  class="ml-2" @click.prevent="getJwtBeforeRedirect(project.attachmentId)" href="" >{{project.attachment}}</a>
                      </div>
                      <v-btn class="bg-white" color="black" variants="text" icon="tabler-x" @click="clearMultiple('attachment')"></v-btn>
                    </div>
                    <VFileInput v-else counter show-size multiple :disabled="isDelete" v-model="project.attachment" @change="handleOfficalFileMultiple('attachment')" @click="clearMultiple('attachment')"/>
                  </VCol>
                </VRow>
              </v-col>
            </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" md="4">
      <v-card width="" height="100%">
        <v-card-text class="pa-0">
              <v-row class="ma-0">
                <UserInfo
                :isShow="[true,true,true,true,false,false]"
                :application-number="project.applicationNumber"
                :status="project.status"
                :issue-date="project.issueDate"
                :document-number="project.documentNumber"
                :user-info="project.applyUser"
                status-component="ProjectCreationAndPublication"
                />
                <v-col cols="6">
                  <v-list-item>
                      <v-list-item-title>公文發文日期</v-list-item-title>
                      <v-list-item-subtitle>
                        <AppDateTimePicker  :rules="[rules.required]" :disabled="isDelete" v-model="project.issueDate" label="" placeholder="選擇公文日期" />
                      </v-list-item-subtitle>
                  </v-list-item>
                </v-col>
                <v-col cols="6">
                  <v-list-item>
                      <v-list-item-title>公文號</v-list-item-title>
                      <v-list-item-subtitle>
                        <v-text-field v-model="project.documentNumber" :disabled="isDelete" :rules="[rules.required]" required></v-text-field>
                      </v-list-item-subtitle>
                  </v-list-item>
                </v-col>
                <v-col cols="12">
                  <v-list-item>
                    <v-list-item-title>通知對象<Required/></v-list-item-title>
                    <v-btn @click="selectAllAss" variant="tonal" class="mb-2" size="small">選擇所有協會</v-btn>
                    <v-autocomplete
                      :custom-filter="customFilter"
                       v-model="project.depts"
                      :items="associations"
                      color="blue-grey-lighten-2"
                      item-title="depName"
                      item-value="depNo"
                      chips
                      label="選擇協會"
                      closable-chips
                      multiple
                      clearable
                      :rules="[rules.required]"
                      required
                    >
                      <template v-slot:chip="{ props, item }">
                        <v-chip
                          v-bind="props"
                          :text="item.raw.depName"
                        ></v-chip>
                      </template>
                      <template v-slot:item="{ props, item }">
                        <v-list-item
                          v-bind="props"
                          :subtitle="item.raw.depNo"
                          :title="item.raw.depName"
                        ></v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-list-item>
                </v-col>
              </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  </v-form>
  <v-row v-if="project.status==flow[0]">
    <v-col cols="12" >
      <VTabs v-model="tab" style="background:white" class="rounded-t-lg">
        <VTab v-for="n in totalTabs" :key="n" :value="n">
          {{n=='end'?'建議參賽階段':`第${wordNumber[n]}階段`}}
        </VTab>
      </VTabs>

      <VWindow v-model="tab" >
        <VWindowItem v-for="n in totalTabs" :key="n" :value="n"   >
          <v-card  >
            <v-card-text>
              <div v-for="(expense, index) in project.expenses[n]" :key="index" class="mb-4">
                <v-row cols="12">
                  <v-col cols="5" >
                    <div>第{{(index + 1)}}期開始<Required/></div>
                    <AppDateTimePicker :rules="[rules.required]" :disabled="isDelete" v-model="expense.from" label="" 
                    placeholder="選擇日期" :config="{ maxDate: expense.to??'' }"/>
                  </v-col>
                  <v-col cols="1" class="d-flex justify-center align-center" style="line-height:1.5">
                    ~
                  </v-col>
                  <v-col cols="5" >
                    <div>第{{(index + 1)}}期結束<Required/></div>
                    <AppDateTimePicker :rules="[rules.required]" :disabled="isDelete" v-model="expense.to" label="" placeholder="選擇日期"
                      :config="{ minDate: expense.from??'' }" />
                  </v-col>
                  <v-col cols="1" class="d-flex justify-center align-center">
                    <v-btn :disabled="isDelete" v-if="index+1==project.expenses[n].length&&index!==0"
                    class="mt-4" icon="tabler-minus" variant="tonal"
                    @click="removeTime(n)"
                    >
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="11">
                    <div>適用協會</div>
                    <v-btn :disabled="isDelete" @click="selectAllApplicableAss(expense)" variant="tonal" class="mb-2" size="small">選擇所有協會</v-btn>
                    <v-autocomplete
                      :custom-filter="customFilter"
                      v-model="expense.applicableDepts"
                      :items="associations"
                      :disabled="isDelete"
                      color="blue-grey-lighten-2"
                      item-title="depName"
                      item-value="depNo"
                      chips
                      label="選擇適用協會"
                      closable-chips
                      multiple
                      clearable
                    >
                      <template v-slot:chip="{ props, item }">
                        <v-chip
                          v-bind="props"
                          :text="item.raw.depName"
                        ></v-chip>
                      </template>
                      <template v-slot:item="{ props, item }">
                        <v-list-item
                          v-bind="props"
                          :subtitle="item.raw.depNo"
                          :title="item.raw.depName"
                        ></v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </div>
              <v-row>
                <v-col cols="12" class=" d-flex align-center justify-center">
                  <v-btn :disabled="isDelete" icon="tabler-plus"  @click="addExpense(n)"> </v-btn>
                  <div class="dashed-line"></div>
                </v-col>

              </v-row>
              <v-col cols="12">
                <v-btn :disabled="totalTabs.length<2||isDelete" @click="removeStage"> 刪除階段</v-btn>
                <v-btn :disabled="totalTabs.length>=5||isDelete" @click="addStage" class="ml-2"> 新增階段</v-btn>
              </v-col>
            </v-card-text>
          </v-card>

        </VWindowItem>
      </VWindow>
    </v-col>
  </v-row>
  <div v-else>
    <VCard class="my-3">
    <div class="d-flex pa-5 w-100">
      <div
        v-for="tab in totalTabs"
        :key="tab"
        class="flex-grow-1"
        style="flex: 1 1 0; min-width: 0;"
      >
        <div class="border-sm pa-2 text-center">{{tab=='end'?'建議參賽階段':`第${wordNumber[tab]}階段`}}</div>
        <div v-for="(item, itemIndex) in project.expenses[tab=='end'?tab.length-1:tab]" :key="`${tab}-${itemIndex}`">
          <div class="border-sm pa-2 text-center" style="word-break: break-word;">
            <div>{{item.from}}~{{item.to}}</div>
            <div
              v-if="formatApplicableDepts(item.applicableDepts)"
              :ref="(el) => bindChipWrapAlign(el, `${tab}-${itemIndex}`)"
              class="d-flex flex-wrap ga-2 mt-2"
              :class="chipWrapAlign[`${tab}-${itemIndex}`] ? 'justify-start' : 'justify-center'"
            >
              <v-chip
                v-for="label in formatApplicableDeptLabels(item.applicableDepts)"
                :key="label"
                size="default"
                color="primary"
                variant="tonal"
              >
                {{ label }}
              </v-chip>
            </div>
          </div>
        </div>
      </div>
    </div>
    </VCard>
    <v-row v-if="project.status!==flow[0]">
      <v-col cols="12">
        <v-card class="mb-0">
          <v-card-title>審核意見</v-card-title>
          <v-card-text>
            <v-textarea rows="1" auto-grow v-model="project.reviewComments"></v-textarea>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="my-0">
      <v-col cols="12" class="">
        <SignOffHistory
          :form-id="project.formId"
          :refresh="project.refreshFormId"
        />
      </v-col>
    </v-row>
  </div>
</div>
  <ProjectCreationAndPublicationDialog
    v-if="isDialogVisible"
    v-model:isDialogVisible="isDialogVisible"
    @create-stage="createStage"
  />
</template>

<script setup lang="ts">
import ProjectCreationAndPublicationDialog from './ProjectCreationAndPublicationDialog.vue'
import { reactive, nextTick, onUnmounted } from 'vue';
import UserInfo from './UserInfoComponent.vue';
import SignOffHistory from '../../../components/SignOffHistoryComponent.vue';
import Required from '../../../components/required.vue'
definePage({
    meta: {
        action: 'manage', //固定為 manage
        subject: 'PROJECT', //系統代碼(系統授權設定中的系統代碼)
    },
})
// [草稿, 申請 , 收回,駁回, 核准,結案,代表隊遴選]
const loadingBtn = ref(false)
const formRef = ref(null); // 使用 ref 获取表单引用
const fileUrl = useStorage('drFsUrl').value
const flow = reactive(['Draft','Submitted','Revoked','Rejected','Approved','Closed','SelectedForTeam'])
const userDataCookie = useStorage('userData', {}).value
const wordNumber = ['一','二','三','四','五','六','七','八','九','十']
const tab = ref("0");
const route = useRoute();
const applicationNumber = ref(route.query.applicationNumber || '');
const editProject=reactive({})
const isDelete = ref(false)
const isDialogVisible= ref(false)
const actionBtn = reactive({})
const project = reactive({
  refreshFormId:0,
  formId:'',
  depts:[],
  applyUser:userDataCookie.userno,
  title: '',
  document: [],
  documentId: '',
  attachment: [],
  attachmentId: '',
  example: [],
  exampleId: '',
  memberSampleFile:[],
  memberSampleFileId:'',
  selectionMethod: '',
  // unit: 'dd',
  applicationNumber: '',
  status: flow[0],
  issueDate: '',
  documentNumber: '',
  notificationTarget: '',
  expenses: [
    [{ from: '', to: '', applicableDepts: [] }],
    [{ from: '', to: '', applicableDepts: [] }],
    [{ from: '', to: '', applicableDepts: [] }],
  ],
  reviewComments: '',
});
const dialogBtn=ref(false)
const totalTabs = reactive([0,1,2])

const rules = ref({
  required: (value: any) => {
    if(Array.isArray(value)){
      return value.length>0 ||'此欄位為必填'
    }else{
      return !!value || '此欄位為必填'
    }
  },
  fileLimitLength: (value: any) =>{
    if(Array.isArray(value)){
      if(value.length>2){
        return '只允許最多兩個檔案'
      }else{
        return value.length>0 && value.length<3 ||'此欄位為必填'
      }
    }
  },
});

const popSwal = (icon, title, text) => {
  $swal({
    position: 'top-end',
    icon: icon,
    title: title,
    text: text,
    showConfirmButton: false,
    ...(icon === 'success' ? { timer: 1500 } : {}),
    customClass: {
      confirmButton: 'btn btn-primary',
    },
    buttonsStyling: false,
  });
}

const selectAllAss =() =>{
  let arr = associations.value.map(item => item.depNo)
  project.depts = arr
}
const selectAllApplicableAss = (expense) => {
  expense.applicableDepts = associations.value.map(item => item.depNo)
}
const customFilter =(itemTitle, queryText, item)=> {
  const textOne = item.raw.depName.toLowerCase()
  const textTwo = item.raw.depNo.toLowerCase()
  const searchText = queryText.toLowerCase()
  return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
}


// 新增階段的日期
function addExpense(index: number) {
  project.expenses[index].push({ from: '', to: '', applicableDepts: [] });
}
// 刪除階段時間
function removeTime(index: number) {
  project.expenses[index].pop();
}
// 新增階段
function addStage() {
  totalTabs.push(totalTabs.length)
  project.expenses.push([{ from: '', to: '', applicableDepts: [] }, { from: '', to: '', applicableDepts: [] }]);
}
// 移除階段
function removeStage() {
  totalTabs.pop()
  project.expenses.pop();
  if(tab.value==totalTabs.length){
    tab.value = totalTabs[totalTabs.length-1]
  }
}
// 上傳公文
const handleOfficalPdfFile = (val) => {
  if (project.document) {
    let arr =[]
    const formData = new FormData();
    project.document.forEach((file, index) => {
      formData.append('file', file);
    });
    // API包含公文號及公文日期
    uploadPdfFile(formData,val)
  }
};
// 上傳文件
const handleOfficalFile = (val) => {
  if (project[val]) {
    // let arr =[]
    const formData = new FormData();
    project[val].forEach((file, index) => {
      formData.append('file', file);
    });
    uploadFile(formData,val+'Id')
  }
};
// 上傳文件 -多檔上傳
const handleOfficalFileMultiple = (val) => {
  if (project[val]) {
    // let arr =[]
    const formData = new FormData();
    project[val].forEach((file, index) => {
      formData.append('multiFiles', file);
    });
    uploadFileMultiple(formData,val+'Id')
  }
};
// 新增階段
const createStage = (val) =>{
  let project = {
    projectId:applicationNumber.value,
    stage: "end",
    startDate: noFarmatWestern(val.from, '-'),
    endDate: noFarmatWestern(val.to, '-'),
  }
  addStageApi(project)
}

// API-----------------------------------------------------
// 上傳公文文件
const uploadPdfFile =async(files,val)=>{
  try {
    const response = await $api(`/tca/docFile/upload`, {
      method: 'POST',
      body: files,
    });
    project[val] = response.dto.fileId
    if(response.pubDate){
      project.issueDate = response.pubDate.replace(/\//g, '-')
    }
    project.documentNumber = response.docNo
  } catch (error) {
    popSwal('error',"上傳公文失敗",error.message || "請稍後再試")
  }
}
// 上傳文件
const uploadFile =async(files,val)=>{
  try {
    const response = await $api(`/tca/file/upload`, {
      method: 'POST',
      body: files,
    });
    project[val] = response.fileId
  } catch (error) {
    popSwal('error',"上傳失敗",error.message || "請稍後再試")
  }
}
// 上傳文件-多檔
const uploadFileMultiple =async(files,val)=>{
  try {
    const response = await $api(`/tca/file/uploadFiles`, {
      method: 'POST',
      body: files,
    });
    project[val] = response.zipIdd
  } catch (error) {
    popSwal('error',"上傳失敗",error.message || "請稍後再試")
  }
}

// 👉 協會API
const { data: subDeptsData, execute: fetchSubDept } = await useApi<any>(createUrl('/du/org/class/getSubDept', {
  query: {
    upperDepNo: 'asso' ,
  },
}))

const associations = computed(()=>{
  return subDeptsData.value?subDeptsData.value:[]
  }
)

// 新增計畫項目申請API
const addProject = async (project, stageList) => {
  loadingBtn.value=true
  console.log(project);
  await $api('/tca/project/add', {
    method: 'POST', //依據後端 restful api 的 method 設定
    body: {
      project:project,
      stageList:stageList,
    }, // requst body
  }).then((resp) => {
    popSwal('success','新增成功','')
    getProject(resp.project.projectId)
    loadingBtn.value=false
  })
};
// 更新計畫項目申請API
const updateProject = async (project, stageList) => {
  loadingBtn.value=true
  await $api('/tca/project/update', {
    method: 'POST', //依據後端 restful api 的 method 設定
    body: {
      project:project,
      stageList:stageList,
    }, // requst body
  }).then((resp) => {
    popSwal('success','修改成功','')
    getProject(resp.project.projectId)
    loadingBtn.value=false
  })
};

// 取得計畫項目申請API
const getProject = async (val) => {
  let applicationNo = val?val:applicationNumber.value
  const apiUrl='/tca/project/get/'+applicationNo
  await $api(apiUrl, {
    method: 'GET', //依據後端 restful api 的 method 設定
  }).then((resp) => {
    Object.assign(editProject, resp)
    updateForm()
    checkStage({
      projectId:resp.project.id,
      stage: "end"
    })
    if(resp.project.formId){
      // isDelete.value=true
      project.formId = resp.project.formId
      // getWorkHistory(resp.project.formId)
      getFormActions(resp.project.formId)
    }
    if(resp.project.formId){
      project.refreshFormId++
    }
  })
};

// 刪除計畫API
const deleteProject =async()=>{
  loadingBtn.value=true
  const apiUrl='/tca/project/delete/'+applicationNumber.value
  await $api(apiUrl, {
    method: 'DELETE', //依據後端 restful api 的 method 設定
  }).then((resp) => {
    popSwal('success','刪除成功','')
    isDelete.value=true
    loadingBtn.value=false
  }).catch((error) =>{
    popSwal('error','請稍後再試','')
    loadingBtn.value=false
  })
}
// 更新狀態API
const updateStatus =async(body)=>{
  loadingBtn.value=true
  await $api('/tca/project/updateStatus', {
    method: 'POST', //依據後端 restful api 的 method 設定
    body:body
  }).then((resp) => {
    popSwal('success','更新狀態成功','')
    getProject(resp.project.projectId)
    loadingBtn.value=false
    // isDelete.value=true
  }).catch((error) =>{
    popSwal('error','更新狀態失敗 請稍後再試','')
    loadingBtn.value=false
  })
}
// 取得簽核歷程API
const getWorkHistory = async(formId)=>{
  let apiUrl = '/form/getWorkHistory/'+formId
  await $api(apiUrl, {
    method: 'GET', //依據後端 restful api 的 method 設定
  }).then((resp) => {
    Object.assign(project.signOffProcess, resp)
  })
}
// 檢查階段資訊是否存在API
const checkStage =async(body)=>{
  await $api('/tca/project/checkStage', {
    method: 'POST', //依據後端 restful api 的 method 設定
    body:body
  }).then((resp) => {
    dialogBtn.value = resp.isExist
  }).catch((error) =>{
    console.log('檢查階段資訊是否存在API',error)
  })
}
// 取得可執行動作API
const getFormActions = async (formId) => {
  let apiUrl = '/form/getFormActions/' + formId;
  await $api(apiUrl, {
    method: 'GET',
  }).then((resp) => {
    if (resp) {
      Object.assign(actionBtn, resp);
    } else {
      console.error("Invalid response structure", resp);
    }
    console.log(actionBtn)
  }).catch((error) => {
    console.error("API request failed", error);
  });
};
// 新增dialog階段資訊API
const addStageApi =async(body)=>{
  await $api('/tca/project/addStage', {
    method: 'POST', //依據後端 restful api 的 method 設定
    body:body
  }).then((resp) => {
    updateStatus({
      projectId: project.applicationNumber,
      status: flow[6],
    })
    getProject(applicationNumber.value)
    checkStage({
      projectId:project.applicationNumber,
      stage: "end"
    })
    isDialogVisible.value=false
  }).catch((error) =>{
    console.log('新增dialog階段資訊API',error)
  })
}
// 取得檔案
const getFile = async (code) => {
  let apiUrl = fileUrl+'/api/v2/files/nstc/' + code + '/meta';
  try {
    const resp = await $api(apiUrl, {
      method: 'GET',
    });
    if (resp) {
      return resp;
    } else {
      console.error("Invalid response structure", resp);
      return null;
    }
  } catch (error) {
    console.error("API request failed", error);
    return null;
  }
}
// JWT
const getJ = async()=>{
  const { data: jwt } = await useApi<any>(createUrl('/tca/file/get', {})) 
  return jwt
}
// -------------------------------------------------------------API

// file 下載
const getJwtBeforeRedirect = async (fileId) => {
  const jwt = await getJ();
  let url = `${fileUrl}/api/v2/files/nstc/${fileId}?drJwt=${jwt.value}`;
  window.open(url, '_blank');
};

const saveData = async() =>{
  let projectProps =  {
    projectId:project.applicationNumber,
    projectTitle: project.title,
    docNo:project.documentNumber,
    publishDate: rocToWestern(project.issueDate,'-','-'),
    notifyDeptNo: project.depts.toString(),
    docFile: project.documentId,
    planSampleFile: project.exampleId,
    memberSampleFile: project.memberSampleFileId,
    otherFile: project.attachmentId,
  }
  return projectProps
}
// 儲存按鈕btn
const save = async() =>{
  const valid = await submit()
  if(valid){
    let projectProps =  await saveData()
    delete projectProps.projectId
    let stageList = transformExpenses(project.expenses)
    if(stageList){
      console.log(projectProps)
      addProject(projectProps,stageList)
    }
  }
}
// 編輯儲存btn
const editSave = async() =>{
  const valid = await submit()
  if(valid){
    let projectProps =  await saveData()
    let stageList = transformExpenses(project.expenses)
    if(stageList){
      if(route.query){
        updateProject(projectProps,stageList)
      }
    }
  }
}
// 送出btn 將狀態草稿>申請
const send = ()=>{
  let projectProps =  {
    projectId:project.applicationNumber,
    status:flow[1]
  }
  updateStatus(projectProps)
}
// 刪除btn 
const deleteBtn = ()=>{
  $swal({
    title: `刪除資料`,
    text: `${project.applicationNumber}`,
    showCancelButton: true,
    confirmButtonText: "我要刪除",
    cancelButtonText: "取消",
  }).then((result) => {
  /* Read more about isConfirmed, isDenied below */
    if (result.isConfirmed) {
      deleteProject()
    }
  });
}
// 核准btn 將狀態申請>核准
const approve = ()=>{
  let projectProps =  {
    projectId:project.applicationNumber,
    status:flow[4],
    remark:project.reviewComments
  }
  updateStatus(projectProps)
}
// 收回btn
const revoke =()=>{
  let projectProps =  {
    projectId:project.applicationNumber,
    status:flow[2],
    remark:project.reviewComments
  }
  updateStatus(projectProps)
}
// 駁回btn
const reject =()=>{
  $swal({
    title: `駁回資料`,
    text: `${project.applicationNumber}`,
    showCancelButton: true,
    confirmButtonText: "我要駁回",
    cancelButtonText: "取消",
  }).then((result) => {
  /* Read more about isConfirmed, isDenied below */
    if (result.isConfirmed) {
      let projectProps =  {
        projectId:project.applicationNumber,
        status:flow[3],
        remark:project.reviewComments
      }
      updateStatus(projectProps)
    }
  });
}
// 結案
const endCase =()=>{
  let projectProps =  {
    projectId:project.applicationNumber,
    status:flow[5],
  }
  updateStatus(projectProps)
}
// 儲存時時間轉換
const dateChange = (date) =>{
  const dateParts = date.split('-');
  let y = Number(dateParts[0])+1911
  return `${y}${dateParts[1]}${dateParts[2]}`
}
// 轉換成後端所需時間和是stageList
const transformExpenses = (expenses) => {
  let result = [];
  for (let stageIndex = 0; stageIndex < expenses.length; stageIndex++) {
    let stage = expenses[stageIndex];
    for (let periodIndex = 0; periodIndex < stage.length; periodIndex++) {
      let period = stage[periodIndex];
      if (period.from && period.to) {
        if( Number(dateChange(period.from)) < Number(dateChange(period.to)) ){
          result.push({
            stage: `${stageIndex + 1}.${periodIndex + 1}`,
            startDate: noFarmatWestern(period.from, '-'),
            endDate: noFarmatWestern(period.to, '-'),
            applicableDeptNo: Array.isArray(period.applicableDepts) && period.applicableDepts.length
              ? period.applicableDepts.toString()
              : '',
          });
        }else{
          popSwal('error',`請確認第${ wordNumber[stageIndex]}階段第${periodIndex + 1}期起訖日填寫`,'結束時間不可比開始時間早')
          return;
        }
      }else{
        popSwal('error',`請確認第${ wordNumber[stageIndex]}階段第${periodIndex + 1}期起訖日填寫`,`第${ wordNumber[stageIndex]}階段第${periodIndex + 1}期起訖日`)
        return;
      }
    }
  }
  return result;
}
// 將後端資料轉成前端stageList格式
const expenses = (stageList) => {
  let expenses = [];
  let currentStageGroup = [];
  let currentStageMain = null;
  for (let stage of stageList) {
    const [stageMain] = stage.stage.split('.');
    if (currentStageMain === null || currentStageMain !== stageMain) {
      if (currentStageGroup.length > 0) {
        expenses.push(currentStageGroup);
      }
      currentStageGroup = [];
      currentStageMain = stageMain;
    }
    currentStageGroup.push({
      from: westernToRoc(formattedDateArray(stage.startDate, '/'),'-'),
      to: westernToRoc(formattedDateArray(stage.endDate, '/'),'-'),
      applicableDepts: stage.applicableDeptNo
        ? stage.applicableDeptNo.split(',').filter(Boolean)
        : [],
    });
  }
  if (currentStageGroup.length > 0) {
    expenses.push(currentStageGroup);
  }
  totalTabs.splice(0, totalTabs.length)
  for(let i =0;i<expenses.length;i++){
    // console.log(stageList)
    if(stageList[stageList.length-1].stage=='end'&&i==expenses.length-1){
      totalTabs.push('end')
    }else{
      totalTabs.push(i)
    }
  }
  return expenses;
};

const formatApplicableDepts = (deptNos) => {
  if (!Array.isArray(deptNos) || deptNos.length === 0) return '';
  const allDepNos = associations.value.map((item) => item.depNo);
  if (
    allDepNos.length > 0
    && deptNos.length === allDepNos.length
    && allDepNos.every((depNo) => deptNos.includes(depNo))
  ) {
    return '全部協會';
  }
  return deptNos
    .map((depNo) => {
      const found = associations.value.find((item) => item.depNo === depNo);
      return found ? found.depName : depNo;
    })
    .join('、');
};

const formatApplicableDeptLabels = (deptNos) => {
  if (!Array.isArray(deptNos) || deptNos.length === 0) return [];
  const allDepNos = associations.value.map((item) => item.depNo);
  if (
    allDepNos.length > 0
    && deptNos.length === allDepNos.length
    && allDepNos.every((depNo) => deptNos.includes(depNo))
  ) {
    return ['全部協會'];
  }
  return deptNos.map((depNo) => {
    const found = associations.value.find((item) => item.depNo === depNo);
    return found ? found.depName : depNo;
  });
};

const chipWrapAlign = reactive({})
const chipWrapObservers = new Map()

const isChipWrapped = (el) => {
  if (!el || !el.children?.length) return false
  const firstTop = el.children[0].offsetTop
  return Array.from(el.children).some((child) => child.offsetTop > firstTop)
}

const updateChipWrapAlign = (el, key) => {
  if (!el) return
  chipWrapAlign[key] = isChipWrapped(el)
}

const bindChipWrapAlign = (el, key) => {
  const prev = chipWrapObservers.get(key)
  if (prev) {
    prev.disconnect()
    chipWrapObservers.delete(key)
  }
  if (!el) {
    delete chipWrapAlign[key]
    return
  }
  nextTick(() => updateChipWrapAlign(el, key))
  const observer = new ResizeObserver(() => updateChipWrapAlign(el, key))
  observer.observe(el)
  chipWrapObservers.set(key, observer)
}

const formattedDateArray = (date, separator) => {
  // 假设 date 是 'YYYYMMDD' 格式的字符串
  return `${date.slice(0, 4)}${separator}${date.slice(4, 6)}${separator}${date.slice(6, 8)}`;
};
// dialog-建議參賽名單通知
const handleDialogVisiable = ()=>{
  isDialogVisible.value=true
}
// 清除file 及fileId
const clear =(fileName)=>{
  project[fileName]=[]
  project[fileName+'Id']=''
}
// 清除file 及fileId - 多檔
const clearMultiple =(fileName)=>{
  project[fileName]=[]
  project[fileName+'Id']=''
}
// validate formRef
const submit = async () => {
  console.log('submit')
  const { valid } = await formRef.value.validate();
  console.log(valid)
  return valid
};

const updateForm = () =>{
  applicationNumber.value=editProject.project.projectId
  project.title=editProject.project.projectTitle
  project.applicationNumber=editProject.project.projectId
  project.issueDate=formatDateToROC(editProject.project.publishDate)
  project.status = editProject.project.status || flow[0]
  project.documentNumber=editProject.project.docNo
  project.expenses=expenses(editProject.stageList)
  project.documentId = editProject.project.docFile
  project.document = editProject.docFileName
  project.attachmentId = editProject.project.otherFile
  if (editProject.otherFileName) {
    project.attachment = editProject.otherFileName
  } else if (editProject.project.otherFile) {
    project.attachment = editProject.project.otherFile
  } else {
    project.attachment = []
  }
  project.exampleId = editProject.project.planSampleFile
  project.example = editProject.planSampleFileName
  project.memberSampleFileId = editProject.project.memberSampleFile
  project.memberSampleFile = editProject.memberSampleFileName
  project.applyUser = editProject.project.applyEmpNo
  console.log(editProject.project.notifyDeptNo.split(','))
  if(editProject.project.notifyDeptNo&&editProject.project.notifyDeptNo.length>0){
    project.depts.splice(0,project.depts.length, ...editProject.project.notifyDeptNo.split(','))
  }else{
    project.depts.splice(0,project.depts.length)
  }
}

// formatDate
const formatDateToAD = (pubdate: string)=>{
  let year, month, day;

  // 判斷日期格式是否包含 '/'
  if (pubdate.includes('/')) {
    [year, month, day] = pubdate.split('/');
  } else if (pubdate.length === 7) {
    // 如果沒有 '/' 且長度為 7，則直接按民國年、月、日分割
    year = pubdate.slice(0, 3);
    month = pubdate.slice(3, 5);
    day = pubdate.slice(5, 7);
  } else {
    return pubdate;
  }
  // 將民國年轉換為西元年
  year = parseInt(year) + 1911;

  pubdate = `${year}-${month}-${day}`;
  // 將所有部分合併成新的格式
  return pubdate;
};

const formatDateToROC = (pubdate: string)=>{
  let formattedDate = pubdate;

  // 檢查日期是否包含 '-' 或 '/'
  if (formattedDate.includes('-')) {
    // 如果包含 '-', 保持原格式
    // do nothing
  } else if (formattedDate.includes('/')) {
    // 如果包含 '/', 用 '-' 替換 '/'
    formattedDate = formattedDate.replace(/\//g, '-');
  } else if (formattedDate.length === 8) {
    // 如果是無分隔符的格式，例如 YYYYMMDD，則轉換為 YYYY-MM-DD
    formattedDate = `${formattedDate.slice(0, 4)}-${formattedDate.slice(4, 6)}-${formattedDate.slice(6, 8)}`;
  }

  // 分割日期成 年-月-日
  const [year, month, day] = formattedDate.split('-');

  // 確保年份是合法的西元年
  if (parseInt(year) > 1911) {
    // 將西元年轉換為民國年
    const rocYear = parseInt(year) - 1911;
    // 拼接成民國日期格式
    pubdate = `${rocYear}-${month}-${day}`;
  }
  return pubdate;
};

watch(editProject, async () => {
  updateForm();
  if(editProject.project.formId){
    getFormActions(project.formId)
  }
});

// 使用 watch 監控查詢參數變化
watch(() => route.query.applicationNumber, async (newValue) => {
  if (newValue !== applicationNumber.value) {
    applicationNumber.value = newValue || '';
    project.applicationNumber = newValue || '';
    getProject(applicationNumber.value);
  }
});
    
// onMounted 用來初始化數據
onMounted(() => {
  project.applicationNumber = route.query.applicationNumber || '';
  if(route.query.applicationNumber){
    getProject(route.query.applicationNumber)
  }
});

onUnmounted(() => {
  chipWrapObservers.forEach((observer) => observer.disconnect())
  chipWrapObservers.clear()
});
</script>


<style scoped>
.dashed-line {
  border: none;
  border-top: 2px dashed rgb(115 103 240 / 30%);
  width: 100%;
  height: 0;
}
.bg-white{
  background:none !important;
  box-shadow: none !important;
}
</style>
